import classNames from "classnames";
import styles from "./StickyBottomSheet.module.css";
import { PropsWithChildren } from "react";

type StickyBottomSheetProps = PropsWithChildren<{
  isVisible: boolean;
}>;

export const StickyBottomSheet = (props: StickyBottomSheetProps) => {
  const { isVisible, children } = props;

  const elementClassNames = classNames(styles.stickyBottomSheet, {
    [styles.isVisible]: isVisible,
  });

  return (
    <div className={elementClassNames} aria-hidden={!isVisible} inert={!isVisible}>
      <div className={styles.contentWrapper}>{children}</div>
    </div>
  );
};
